import React from 'react'
import { AppProvider } from './context/AppContext'
import { AuthProvider } from './context/AuthContext'
import AppRouter from './components/Router/AppRouter'
import ToastContainer from './components/Toast/ToastContainer'
import SessionTimeoutHandler from './components/Auth/SessionTimeoutHandler'
import './styles/App.css'

// Main App component with authentication
function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <AppRouter />
        <SessionTimeoutHandler />
        <ToastContainer />
      </AppProvider>
    </AuthProvider>
  )
}

export default App